<stx-checkbox-group-filter
  [formGroupReference]="formGroupReference"
  filterName="exclusions"
  [dictionaryOptions]="dictionaryOptions"
  (filterChange)="onFilterChange($event)"
></stx-checkbox-group-filter>
